/* eslint-disable @typescript-eslint/no-explicit-any */
import $ from 'jquery';

require('block-ui');

declare global {
    interface JQueryStatic {
        blockUI: (config: any) => void;
        unblockUI: () => void;
    }
}

export default $;
